import React from 'react';

import { useAppDispatch, useAppSelector } from '../../../hooks/react-redux';
import { useFetchStarted } from '../../../hooks/useFetchStarted';
import { PlusButton } from '../../shared/button/PlusButton';
import { toggleUsersModal } from './store';
import { getModalOpen } from './store/selectors';
import { UpsertUserModal } from './UpsertUserModal';
import styles from './Users.module.scss';
import { UsersTable } from './UsersTable';
import { fetchAllAccessGroupsStarted } from '../access-groups/store';

export const Users: React.FC = () => {
    const dispatch = useAppDispatch();
    useFetchStarted([fetchAllAccessGroupsStarted()]);

    const handleModalToggle = (isOpen: boolean) => dispatch(toggleUsersModal(isOpen));
    const openModal = () => handleModalToggle(true);
    const closeModal = () => handleModalToggle(false);

    const modalOpen = useAppSelector(getModalOpen);

    return (
        <div className={styles.usersWrapper} data-testid='users-wrapper'>
            <div className={styles.usersTitleContainer}>
                <div className={styles.usersTitle} data-testid='users-title'>Users</div>
                <PlusButton onClick={openModal} fontSize={22} testId='create-user' />
                <UpsertUserModal isOpen={modalOpen} closeModal={closeModal} />
            </div>
            <UsersTable />
        </div>
    );
};
